import _str from "shared/util/_str";
import OkInstagram from "shared/modules/OkInstagram";

import * as web from "apps/profile_instagram/util/web";


// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	activeSection: null,
	isLoadingInstagram: false,
	instagramPhotos: undefined,
	instagramError: null,
};

const getInitialState = () => {
	return INITIAL_STATE;
};


// action types
// ----------------------------------------------------------------------------

export const LOAD_INSTAGRAM = "PROFILE_INSTAGRAM.LOAD_INSTAGRAM";
export const LOAD_INSTAGRAM_SUCCESS = "PROFILE_INSTAGRAM.LOAD_INSTAGRAM_SUCCESS";
export const LOAD_INSTAGRAM_FAILURE = "PROFILE_INSTAGRAM.LOAD_INSTAGRAM_FAILURE";
export const CONNECT_INSTAGRAM = "PROFILE_INSTAGRAM.CONNECT_INSTAGRAM";
export const CONNECT_INSTAGRAM_SUCCESS = "PROFILE_INSTAGRAM.CONNECT_INSTAGRAM_SUCCESS";
export const CONNECT_INSTAGRAM_FAILURE = "PROFILE_INSTAGRAM.CONNECT_INSTAGRAM_FAILURE";
export const DISCONNECT_INSTAGRAM = "PROFILE_INSTAGRAM.DISCONNECT_INSTAGRAM";
export const DISCONNECT_INSTAGRAM_SUCCESS = "PROFILE_INSTAGRAM.DISCONNECT_INSTAGRAM_SUCCESS";
export const DISCONNECT_INSTAGRAM_FAILURE = "PROFILE_INSTAGRAM.DISCONNECT_INSTAGRAM_FAILURE";


// reducer
// ----------------------------------------------------------------------------

export function reducer(state = getInitialState(), action) {
	switch (action.type) {
		case LOAD_INSTAGRAM: {
			return {
				...state,
				isLoadingInstagram: true,
			};
		}

		case LOAD_INSTAGRAM_SUCCESS: {
			return {
				...state,
				isLoadingInstagram: false,
				instagramPhotos: action.payload.instagramPhotos,
			};
		}

		case LOAD_INSTAGRAM_FAILURE: {
			return {
				...state,
				isLoadingInstagram: false,
				instagramError: action.payload.message,
			};
		}

		case CONNECT_INSTAGRAM: {
			return {
				...state,
				isLoadingInstagram: true,
			};
		}

		case CONNECT_INSTAGRAM_SUCCESS: {
			return {
				...state,
				isLoadingInstagram: false,
			};
		}

		case CONNECT_INSTAGRAM_FAILURE: {
			return {
				...state,
				isLoadingInstagram: false,
				instagramError: action.payload.message,
			};
		}

		case DISCONNECT_INSTAGRAM: {
			return {
				...state,
				isLoadingInstagram: true,
			};
		}

		case DISCONNECT_INSTAGRAM_SUCCESS: {
			return {
				...state,
				isLoadingInstagram: false,
				instagramPhotos: undefined,
			};
		}

		case DISCONNECT_INSTAGRAM_FAILURE: {
			return {
				...state,
				isLoadingInstagram: false,
				instagramError: action.payload.message,
			};
		}

		default: {
			return state;
		}
	}
}


// actions
// ----------------------------------------------------------------------------

export const loadInstagram = (userid) => {
	return (dispatch) => {
		dispatch({ type: LOAD_INSTAGRAM });

		web.loadInstagram(userid)
			.then((res) => {
				dispatch({
					type: LOAD_INSTAGRAM_SUCCESS,
					payload: {
						instagramPhotos: res,
					},
				});
			})
			.catch((err) => {
				let message = _str("There was a problem loading the Instagram photos");

				if (err && err.error && err.error.message) {
					message = `${message}: ${err.error.message}`;
				} else {
					message = `${message}!`;
				}

				dispatch({
					type: LOAD_INSTAGRAM_FAILURE,
					error: true,
					payload: {
						message,
					},
				});
			});
	};
};


export const connectInstagram = (userid, successCallback) => {
	return (dispatch) => {
		dispatch({ type: CONNECT_INSTAGRAM });

		OkInstagram.connect({
			onSuccess: () => {
				dispatch({ type: CONNECT_INSTAGRAM_SUCCESS });
				dispatch(loadInstagram(userid));
				successCallback();
			},
			onFailure: () => {
				dispatch({
					type: CONNECT_INSTAGRAM_FAILURE,
					error: true,
					payload: {
						message: _str("We could not connect your Instagram account!"),
					},
				});
			},
			activate: true,
		});
	};
};

export const disconnectInstagram = (disconnectSuccessCallback) => {
	return (dispatch) => {
		dispatch({ type: DISCONNECT_INSTAGRAM });

		OkInstagram.disconnect()
			.then(() => {
				dispatch({
					type: DISCONNECT_INSTAGRAM_SUCCESS,
				});
				disconnectSuccessCallback();
			})
			.catch(() => {
				dispatch({
					type: DISCONNECT_INSTAGRAM_FAILURE,
					error: true,
					payload: {
						message: _str("We could not disconnect your Instagram account!"),
					},
				});
			});
	};
};



// WEBPACK FOOTER //
// ./src/ducks/profile_instagram.js